module.exports = __webpack_public_path__ + "img/thumbnail_GreaterFlamingo_f_normal.91af8c98.png";